import { configureStore } from "@reduxjs/toolkit";

// Reducers
import AccountReducer from "./slices/accountSlice";
import ApiErrorReducer from "./slices/apiErrorsSlice";
import ApplicationReducer from "./slices/applicationSlice";
import LoaderReducer from "./slices/loadersSlice";

const store = configureStore({
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    account: AccountReducer,
    apiErrors: ApiErrorReducer,
    application: ApplicationReducer,
    loaders: LoaderReducer,
  },
});

export default store;
